module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-dorm-medium-12157281a9fedf9518d7c46d54a133f3.jpg";